import type * as React from "react";

function shouldHandleLinkClick(event: React.MouseEvent<HTMLElement>) {
  return (
    !event.defaultPrevented &&
    event.button === 0 &&
    !event.metaKey &&
    !event.altKey &&
    !event.ctrlKey &&
    !event.shiftKey
  );
}

export function handlePlainLinkClick(
  event: React.MouseEvent<HTMLElement>,
  onNavigate?: () => void,
) {
  if (!onNavigate || !shouldHandleLinkClick(event)) return;

  event.preventDefault();
  onNavigate();
}
